import { render, staticRenderFns } from "./FundraiserEventStats.vue?vue&type=template&id=8f46bac4&lang=html&"
import script from "./FundraiserEventStats.vue?vue&type=script&lang=js&"
export * from "./FundraiserEventStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports